/**
 * Хелперы «Отчётов»: пресеты периода и форматирование дат бакетов.
 */

import dayjs from 'dayjs';

import type {ReportPeriod} from '@services/reports';

export const REPORT_PERIODS: {key: ReportPeriod; label: string}[] = [
  {key: '7d', label: '7 дней'},
  {key: '1m', label: 'Месяц'},
  {key: '3m', label: '3 месяца'},
  {key: 'all', label: 'Всё время'},
];

/** Подпись бакета динамики: день → «5 авг», месяц → «авг». */
export const fmtBucket = (bucket: string, groupBy: 'day' | 'month'): string =>
  dayjs(bucket)
    .format(groupBy === 'day' ? 'D MMM' : 'MMM')
    .replace('.', '');

/** «11 авг 2026» для заголовка периода свода. */
export const fmtReportDate = (iso: string): string =>
  dayjs(iso).format('D MMM YYYY').replace('.', '');
